<template>
  <div
    class="pb-4"
    style="min-height: 100vh; max-height: 100vh; overflow-y: auto"
  >
    <section class="p-4">
      <h5 class="mb-3">Event Insight: {{ eventName }}</h5>
      <div class="row">
        <div class="col-md-6" :key="dateType">
          Show chart as
          <select
            class="custom-select"
            style="width: auto !important; height: 36px"
            v-model="dateType"
            @change="loadData()"
          >
            <option value="date">Date</option>
            <option value="month">Month</option>
          </select>
        </div>
        <div class="col-md-6 ml-auto text-right">
          <AirbnbDatePicker module="events"></AirbnbDatePicker>
        </div>
      </div>
      <div class="row">
        <div
          class="col-xs-12 col-md-12 col-lg-12"
          :key="dateType"
          height="200px"
        >
          <div id="linebox">
            <div class="box-content">
              <canvas id="event-chart" height="300px"></canvas>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="row" v-if="availableProp.length">
      <div class="col-xs-12 col-md-12 col-lg-12">
        Group by properties:
        <select
          @change="addProp()"
          class="custom-select mb-3"
          style="width: auto !important; height: 36px"
          v-model="selectedProp"
        >
          <option value>properties</option>
          <template v-for="(item, key) in availableProp">
            <option v-if="!groupbyKey.includes(item)" :key="key" :value="item">
              {{ item }}
            </option>
          </template>
        </select>
      </div>
    </div>

    <template v-if="groupbyKey.length">
      <div class="row mb-3">
        <div class="col-xs-12 col-md-12 col-lg-12">
          <span v-for="(item, key) in groupbyKey" v-bind:key="key">
            <span class="criteria no-drag">
              <b>{{ item | capitalize }}</b>
              <span
                style="font-size: 14px"
                class="ml-1 cursor-pointer text-danger cursor-pointer"
                @click="removeProp(item)"
                >x</span
              >
            </span>
          </span>
        </div>
      </div>
    </template>

    <div class="row mb-4">
      <div class="col-md-12 px-0">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th class="pl-4 ml-4">Event</th>
                <template v-for="(propKey, key1) in groupbyKey">
                  <th :key="key1">{{ propKey }}</th>
                </template>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              <!-- item[0] !== '' -->
              <template v-if="groupedData.length">
                <tr v-for="(item, key) in groupedData" :key="key">
                  <td
                    style="border-right: 1px solid #eeeeee"
                    class="align-top eventName pl-4 ml-4"
                  ></td>
                  <td
                    v-bind:class="{ borderTop: item[0] !== '' }"
                    v-for="(item2, key2) in item"
                    :key="key2"
                  >
                    {{ item2 }}
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td
                    style="border-right: 1px solid #eeeeee"
                    class="align-top eventName"
                  ></td>
                  <td>{{ count }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
const AirbnbDatePicker = () => import('@/components/AirbnbDatePicker.vue')

require('../../../static/js/dashboard.js')

/* eslint-disable */
export default {
  data: function () {
    return {
      option: 'all',
      chart: undefined,
      clearState: false,
      startDate: '',
      endDate: '',
      dateType: 'date',
      groupbyKey: [],
      groupedData: [],
      selectedProp: '',
      availableProp: [],
      count: 0,
    }
  },
  props: [
    'name',
    'boldTitle',
    'height',
    'clearState',
    'legend',
    'fullview',
    'eventText',
    'eventName',
    'eventType',
    'properties',
  ],
  store,
  components: {
    AirbnbDatePicker,
  },
  mounted() {
    // let keys = new Set()
    // for (let i in this.properties) {
    //   keys.add(this.properties[i].name)
    // }
    // this.groupbyKey = Array.from(keys)
    // this.properties.sort((a, b) => (a.count < b.count ? 1 : -1))
    this.availableProp = this.getAvailableAttribute()
    this.startDate = this.$store.getters.datepicker.events.startDate || ''
    this.endDate = this.$store.getters.datepicker.events.endDate || ''
    this.populateData([])
    this.loadData()
  },
  watch: {
    '$store.getters.datepicker.events': {
      handler: function (date) {
        this.startDate = date.startDate
        this.endDate = date.endDate
        // this.changePeriod()

        this.loadData()
        this.updateProperty()
      },
      deep: true,
    },
  },
  methods: {
    updateProperty() {
      // alert(this.eventType)
      this.$http
        .post(process.env.API_ENDPOINT + '/events', {
          widget_id: this.$session.get('widget_id'),
          startDate: this.startDate,
          endDate: this.endDate,
          event_type: this.eventType,
          find: this.id || this.eventText,
        })
        .then((response2) => {
          this.properties = response2.data[0].event_properties
          console.log(this.properties)
          this.populateData([])
        })
    },
    addProp() {
      if (howuku)
        howuku.track('Filter Data', {
          user_id: this.$session.get('user_id'),
          product: 'Event Properties',
          property: this.selectedProp,
        })
      this.groupbyKey.push(this.selectedProp)
      this.selectedProp = ''
      this.populateData(this.groupbyKey)
    },
    removeProp(x) {
      for (let i in this.groupbyKey) {
        if (this.groupbyKey[i] === x) this.groupbyKey.splice(i, 1)
      }
      this.populateData(this.groupbyKey)
    },
    serializeProperty(prop, groupby) {
      function getDeepKeys(obj) {
        var keys = []
        for (var key in obj) {
          keys.push(key)
          if (typeof obj[key] === 'object') {
            var subkeys = getDeepKeys(obj[key])
            keys = keys.concat(
              subkeys.map(function (subkey) {
                return key + '.' + subkey
              })
            )
          }
        }
        return keys
      }
      let serialized = getDeepKeys(prop)
      let pregex = '^'
      let nregex = '^'
      for (let i in groupby) {
        pregex += '.*' + '\\' + '.'
        nregex += '.*' + '\\' + '.'
      }
      nregex += '.*' + '\\' + '.'
      var positive = new RegExp(pregex)
      var negative = new RegExp(nregex)
      for (let i = serialized.length; i >= 0; i--) {
        if (!positive.test(serialized[i]) || negative.test(serialized[i])) {
          serialized.splice(i, 1)
        }
      }
      return serialized
    },
    changePeriod: function (value) {
      this.option = value
      // console.log(value)
      this.clearState = true
      this.loadData()
      this.clearState = false
    },
    getAvailableAttribute() {
      let properties = this.properties.split('|||||')
      properties = properties.join(',')
      properties = JSON.parse('[' + properties + ']')
      let unique = new Set()

      properties.forEach(function (a) {
        let keys = Object.keys(a)
        for (let i in keys) {
          unique.add(keys[i])
        }
      })

      return Array.from(unique)
    },
    populateData(groupby) {
      let int = setInterval(() => {
        try {
          if (document.getElementsByClassName('eventName')) {
            document.getElementsByClassName('eventName')[0].innerHTML =
              this.eventName
            clearInterval(int)
          }
        } catch (err) {}
      }, 100)
      let properties = this.properties.replace(/\./g, 'xxxxx').split('|||||')
      properties = properties.join(',')
      properties = JSON.parse('[' + properties + ']')
      let grouped2 = {}

      if (groupby && groupby.length) {
        let groups = groupby

        properties.forEach(function (a) {
          groups
            .reduce(function (o, g, i) {
              // take existing object,
              o[a[g]] = o[a[g]] || (i + 1 === groups.length ? [] : {}) // or generate new obj, or
              return o[a[g]] // at last, then an array
            }, grouped2)
            .push(a)
        })
      }

      if (typeof grouped2 === 'object') {
        let prop = this.serializeProperty(grouped2, groupby)
        let obj = {}
        for (let i in prop) {
          let key = prop[i].replace(/\.[0-9]+$/, '')
          if (!obj[key]) obj[key] = 0
          obj[key]++
        }

        this.groupedData = []

        for (let i in obj) {
          let col = i.split('.')
          let count = obj[i]
          for (let k in col) {
            col[k] = col[k].replace(/xxxxx/g, '.')
          }
          col.push(count)
          this.groupedData.push(col)
        }

        let removedup = []
        for (let i = 0; i < this.groupedData.length; i++) {
          if (i - 1 >= 0) {
            let row = this.groupedData[i]
            let lastRow = this.groupedData[i - 1]
            for (let j = lastRow.length - 1; j >= 0; j--) {
              if (
                // not equal to count or last grouped cat
                j !== lastRow.length - 1 &&
                j !== lastRow.length - 2 &&
                lastRow[j] === row[j] &&
                row[j - 1] === lastRow[j - 1]
              ) {
                removedup.push(i + '.' + j)
              }
            }
          }
        }

        for (let i in removedup) {
          let coordinate = removedup[i].split('.')
          this.groupedData[coordinate[0]][coordinate[1]] = ''
        }
      }
    },
    loadData: function () {
      this.$http
        .post(process.env.API_ENDPOINT + '/report/eventchart', {
          company_id: this.$session.get('company_id'),
          event_text: this.eventText,
          widget_id: this.$session.get('widget_id'),
          option: this.option,
          event_type: this.eventType,
          date_type: this.dateType,
          start_date: this.startDate,
          end_date: this.endDate,
        })
        .then((response) => {
          this.loadChart(response)
          this.count = 0
          for (let i in response.data) {
            this.count += response.data[i].count
          }
        })
    },
    loadChart: function (response) {
      var borderColor = ''
      var bgColor = ''
      var total = 0
      var dateData = {}

      var data = {
        labels: [],
        datasets: [
          { data: [] },
          { data: [] },
          { data: [] },
          { data: [] },
          { data: [] },
        ],
      }
      let newdata = response.data.reduce(
        (newArray, currentModel, index, originalArray) => {
          const nextModel = originalArray[index + 1]

          if (nextModel) {
            const currentDate = moment(currentModel.date)
            const daysBetween = moment(nextModel.date).diff(currentDate, 'days')

            const fillerDates = Array.from(
              { length: daysBetween - 1 },
              (count, dayIndex) => {
                return {
                  count: 0,
                  date: moment(currentDate)
                    .add(dayIndex + 1, 'days')
                    .format('YYYY-MM-DD'),
                }
              }
            )

            newArray.push(currentModel, ...fillerDates)
          } else {
            newArray.push(currentModel)
          }

          return newArray
        },
        []
      )

      for (let i in newdata) {
        let current = newdata[i]
        let count = current.count
        let date = current.date

        if (!dateData[date]) dateData[date] = {}
        dateData[date] = count
      }

      for (let date in dateData) {
        let count = dateData[date]
        var composedDate = new Date(date)
        let month = composedDate.getMonth() + 1
        data.labels.push(composedDate.getDate() + '/' + month)

        data.datasets[0].data.push(count)
        data.datasets[0].fill = true
        data.datasets[0].label = 'Event'
        data.datasets[0].lineTension = 0
        data.datasets[0].borderWidth = 2
        data.datasets[0].pointRadius = 1
        data.datasets[0].pointHoverRadius = 1
        data.datasets[0].borderColor = '#059ab2'
        data.datasets[0].fill = true
        data.datasets[0].backgroundColor = '#059ab240'
      }

      if (this.chart !== undefined) this.chart.destroy()

      let ctx = document.getElementById('event-chart')
      import('chart.js').then(Chart => {
        this.chart = new Chart(ctx, {
          // eslint-disable-line no-new
          type: 'line',
          data: data,
          options: {
            tooltips: {
              mode: 'index',
              intersect: false,
            },
            hover: {
              mode: 'nearest',
              intersect: true,
            },
            responsive: true,
            maintainAspectRatio: false,
            onClick: function (evt, item) {
              if (item[0]) {
                let label = data.labels[item[0]['_index']]
              }
            },
            legend: {
              display: this.legend ? true : false,
            },
            scales: {
              xAxes: [
                {
                  stacked: false,
                  ticks: {
                    maxRotation: 0,
                  },
                },
              ],
              yAxes: [
                {
                  stacked: false,
                  ticks: {
                    beginAtZero: false,
                  },
                },
              ],
            },
            defaultFontSize: 16,
            layout: {
              padding: {
                top: 30,
              },
            },
          },
        })
      })
    },
    diff: function (date1, date2) {
      let dt1 = new Date(date1)
      let dt2 = new Date(date2)
      return Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      )
    },
    precisionRound: function (number, precision) {
      var factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    },
    getColor: function (rank) {
      let color

      switch (rank) {
        case 1:
          color = '#059ab2'
          break
        case 2:
          color = '#00ac7d'
          break
        case 3:
          color = '#f7c000'
          break
        case 4:
          color = 'rgb(255, 75, 57)'
          break
        default:
          color = 'black'
          break
      }
      return color
    },
    getName: function (rank) {
      let name

      switch (rank) {
        case 1:
          name = 'Great'
          break
        case 2:
          name = 'Good'
          break
        case 3:
          name = 'Bad'
          break
        case 4:
          name = 'Worst'
          break
      }
      return name
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
}
</script>

<style>
.borderless td,
.borderless th {
  border: none;
  padding-bottom: 20px;
}

.borderTop {
  border-top: 1px solid #eeeeee !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/EventChart.vue